import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { useIsEditorReadonly } from '@/hooks/use-is-editor-readonly';
import Editor from '@monaco-editor/react';
import { type ReactNodeViewProps } from '@tiptap/react';

const UnsupportedEditableNodeView: React.FC<ReactNodeViewProps> = ({ node, updateAttributes, selected, decorations, editor }) => {
    const isEditorReadonly = useIsEditorReadonly(editor);
    const content = node.attrs.content || '';

    const handleContentChange = (value: string | undefined) => {
        updateAttributes({ content: value || '' });
    };

    return (
        <ZyNodeViewWrapper
            decorations={decorations}
            className={`my-4 w-full rounded-lg border-2 bg-gray-50 p-3 dark:bg-red-900/20 ${
                selected
                    ? 'border-blue-500 ring-2 ring-blue-500 ring-offset-2 dark:ring-offset-gray-900'
                    : 'border-gray-300 dark:border-gray-700'
            }`}
        >
            <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <span className="text-lg">⚠️</span>
                    <span className="text-sm font-semibold text-red-700 dark:text-red-400">Unsupported Content</span>
                </div>
            </div>

            <div className="mb-3 text-xs text-gray-500 dark:bg-yellow-900/20 dark:text-yellow-400">
                This content does not have a Modern Authoring experience yet. You can edit the zyXML below.
            </div>

            <Editor
                height="200px"
                language="xml"
                value={content}
                onChange={handleContentChange}
                options={{
                    minimap: { enabled: false },
                    fontSize: 13,
                    lineNumbers: 'on',
                    scrollBeyondLastLine: false,
                    automaticLayout: true,
                    tabSize: 2,
                    wordWrap: 'on',
                    formatOnPaste: true,
                    formatOnType: true,
                    readOnly: isEditorReadonly,
                }}
                theme="vs-dark"
            />
        </ZyNodeViewWrapper>
    );
};

export default UnsupportedEditableNodeView;
